import breadcrumbsDirective from "./breadcrumbs-directive";

export {breadcrumbsDirective};
